export default "__VITE_ASSET__FScGFqne__"